module.exports = __webpack_public_path__ + "img/highest_icon.132cea4f.svg";